import { render } from "./Column202501.vue?vue&type=template&id=613739e1&scoped=true"
import script from "./Column202501.vue?vue&type=script&lang=js"
export * from "./Column202501.vue?vue&type=script&lang=js"

import "./Column202501.vue?vue&type=style&index=0&id=613739e1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-613739e1"

export default script